import React, { Component } from 'react';
import NuxContainer from 'app/common/react/components/growth/activation/NuxContainer/NuxContainer';
import PropTypes from 'prop-types';

/**
 * MobileNuxContainer
 *
 * Wrapped component that wraps around NuxContainer. This is specific for mobile nux.
 */

export class MobileNuxContainer extends Component {
  static propTypes = {
    denzel: PropTypes.bool,
    handleComplete: PropTypes.func,
  };

  componentWillUnmount() {
    // mweb nux is a react component that leads into denzel;
    // after completing the experience, it needs to reload the page to proceed
    if (this.props.denzel) {
      window.location.reload();
    }
  }

  render() {
    return <NuxContainer {...this.props} handleComplete={this.props.handleComplete} />;
  }
}

export default MobileNuxContainer;
